/** Mixin handles submitting data to endpoints. The submitting boolean which the component
 *  can use to disable multiple submits etc. The component will also emit the entityCreated
 *  and entityCreated events with the data that was submitted when the submit is complete.
 * @mixin */

export default {
  methods: {
    /**
     * Helper to use when entityType is equal to namespace
     * @param {*} entity - data to be submitted
     * @param {string} entityType - the name/namespace of the entity used in create/update action
     * @param {boolean[]=} additionalErrors - Additional errors to validate
     * @param {function=} submittedCallback - function called when api response is returned
     */
    onSubmit(entity, entityType, additionalErrors, submittedCallback) {
      this.onSubmitToStore(entity, entityType, entityType, additionalErrors, submittedCallback);
    },
    /**
     * Validate form and call submit function for either create or update
     * @param {*} entity - data to be submitted
     * @param {string} namespace - namespace for the store dispatch
     * @param {string} entityType - the name of the entity used in create/update action
     * @param {boolean[]=} additionalErrors - Additional errors to validate
     * @param {function=} submittedCallback - function called when api response is returned
     */
    onSubmitToStore(entity, namespace, entityType, additionalErrors, submittedCallback) {
      this.$validator.validate()
        .then((result) => {
          if (result && (!additionalErrors || (additionalErrors && !additionalErrors.some(error => error === true)))) {
            this.$store.dispatch(`${namespace}/startSubmitting`);
            // if there is an existing id, it is an update. Otherwise it is a post.
            if (entity.id) {
              this.$store.dispatch(
                `${namespace}/updateEntity`, {
                  entityType,
                  entity,
                  closeForm: this.callCloseForm,
                  submittedCallback,
                },
              );
            } else {
              this.$store.dispatch(
                `${namespace}/createEntity`, {
                  entityType,
                  entity,
                  closeForm: this.callCloseForm,
                  submittedCallback,
                },
              );
            }
          }
        });
    },
    callCloseForm(entity) {
      this.$emit('closeForm', entity.id);
    },
  },
};
